<template>
  <div id="app">
    <p class="b-intro non-printable">
      I formuläret Benders Brunnsbeställning fyller du i den information som krävs för att ta fram
      en offert eller lägga en order. Skicka ditt underlag till
      <a class="link" href="mailto:offert@benders.se">offert@benders.se</a>
      för att få en offert, eller till
      <a class="link" href="mailto:order@benders.se">order@benders.se</a>
      för att genomföra en beställning.
    </p>

    <div class="b-shell">
      <div class="b-main">
        <StepIndicator
          :labels="stepLabels"
          :current="currentStep"
          :can-advance="canAdvance"
          @go="goToStep"
        />

        <StepCustomer v-if="currentStep === 0" />

        <StepWells v-else-if="currentStep === 1" />

        <StepSummary v-else :customer="customer" :common="common" :forms="forms" />

        <StepNav
          :show-back="currentStep > 0"
          :can-advance="canAdvance"
          :next-label="currentStep === 2 ? 'Spara som PDF' : 'Nästa'"
          :blocked-reason="blockedReason"
          @back="goBack"
          @next="goNext"
        />
      </div>

      <ChoiceSummary class="b-aside" :customer="customer" :common="common" :forms="forms" />
    </div>

    <PDF
      v-if="forms.length > 0"
      ref="pdfSection"
      :customer="customer"
      :common="common"
      :forms="forms"
      style="visibility: hidden; position: absolute; top: 0; left: 0"
    />
  </div>
</template>

<script>
import StepIndicator from './components/StepIndicator.vue'
import StepCustomer from './components/StepCustomer.vue'
import StepWells from './components/StepWells.vue'
import StepSummary from './components/StepSummary.vue'
import StepNav from './components/StepNav.vue'
import ChoiceSummary from './components/ChoiceSummary.vue'
import PDF from './components/PDF.vue'
import { store, isWeekend } from './store.js'

export default {
  name: 'App',
  components: {
    StepIndicator,
    StepCustomer,
    StepWells,
    StepSummary,
    StepNav,
    ChoiceSummary,
    PDF,
  },

  data() {
    return {
      store,
      currentStep: 0,
      stepLabels: ['Kunduppgifter', 'Brunnar', 'Sammanfattning'],
    }
  },

  computed: {
    customer() {
      return this.store.customer
    },
    common() {
      return this.store.common
    },
    forms() {
      return this.store.forms
    },

    // Steg 0 kräver kunduppgifter, steg 1 kräver littera på alla brunnar.
    // Reglerna bor i store.js tillsammans med fältvalideringen.
    canAdvance() {
      if (this.currentStep === 0) return this.store.customerValid
      if (this.currentStep === 1) return this.store.wellsValid
      return true
    },
    blockedReason() {
      if (this.currentStep === 0) {
        return isWeekend(this.customer.deliveryDate)
          ? 'Önskat leveransdatum måste vara en vardag.'
          : 'Fyll i alla obligatoriska fält (*) för att gå vidare.'
      }
      if (this.currentStep === 1) {
        return this.forms.length === 0
          ? 'Ange minst en brunn för att gå vidare.'
          : 'Alla brunnar måste ha ett littera för att gå vidare.'
      }
      return ''
    },
  },

  methods: {
    goToStep(step) {
      // Framåt bara när innevarande steg är komplett – samma regel som "Nästa".
      if (step > this.currentStep && !this.canAdvance) return
      this.currentStep = step
      this.scrollToTop()
    },
    goBack() {
      if (this.currentStep > 0) this.goToStep(this.currentStep - 1)
    },
    goNext() {
      if (!this.canAdvance) return
      if (this.currentStep === 2) {
        this.generatePdf()
        return
      }
      this.goToStep(this.currentStep + 1)
    },
    // Inbäddad i iframe: be föräldern scrolla, annars scrolla själv.
    scrollToTop() {
      if (window.parent !== window) {
        window.parent.postMessage({ type: 'benders:scrollTop' }, '*')
      }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    generatePdf() {
      const pdfComp = this.$refs.pdfSection
      if (pdfComp && typeof pdfComp.generatePdf === 'function') {
        pdfComp.generatePdf()
      } else {
        alert('Kunde inte generera PDF — komponenten hittades inte.')
      }
    },
  },
}
</script>
